import { GridFilterItem } from "@mui/x-data-grid-pro";

const createFilter = (compareFunction: (cellValue: any | any[], filterValue: any) => boolean) => {
    return (filterItem: GridFilterItem) => {
      if (!filterItem.field || !filterItem.value || !filterItem.operator) {
        return null;
      }
      return (params: any | any[]): boolean => {
        // If we have a value, we're doing client-side filtering
        if (params !== undefined) {
          return compareFunction(params, filterItem.value);
        }
        // Otherwise, we're doing server-side filtering
        return filterItem.value;
      };
    };
  };

  export default createFilter;